import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import Features from './pages/Features'
import Documentation from './pages/Documentation'
import DocsPage from './pages/DocsPage'
import TermsOfService from './pages/TermsOfService'
import Privacy from './pages/Privacy'

function App() {
	return (
		<div className="min-h-screen flex flex-col">
			<Header />
			<main className="flex-grow">
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/features" element={<Features />} />
					<Route path="/docs" element={<Documentation />} />
					<Route path="/features/*" element={<DocsPage />} />
					<Route path="/getting-started/*" element={<DocsPage />} />
					<Route path="/provider-config/*" element={<DocsPage />} />
					<Route path="/mcp/*" element={<DocsPage />} />
					<Route path="/sakadev-cli/*" element={<DocsPage />} />
					<Route path="/prompting/*" element={<DocsPage />} />
					<Route path="/troubleshooting/*" element={<DocsPage />} />
					<Route path="/running-models-locally/*" element={<DocsPage />} />
					<Route path="/core-features/*" element={<DocsPage />} />
					<Route path="/enterprise-solutions/*" element={<DocsPage />} />
					<Route path="/exploring-sakadevs-tools/*" element={<DocsPage />} />
					<Route path="/model-config/*" element={<DocsPage />} />
					<Route path="/custom-model-configs/*" element={<DocsPage />} />
					<Route path="/introduction/*" element={<DocsPage />} />
					<Route path="/more-info/*" element={<DocsPage />} />
					<Route path="/tos" element={<TermsOfService />} />
					<Route path="/privacy" element={<Privacy />} />
				</Routes>
			</main>
			<Footer />
		</div>
	)
}

export default App
